export enum eventStatusType {
  ReturnRequestConfirmation = "return_request_confirmation",
  ReturnRequestApproved = "return_request_approved",
  ReturnRequestRejected = "return_request_rejected",
  RefundToStoreDiscount = "refunded_store_credit_method",
  RefundedToStoreGiftCard = "refunded_to_gift_card",
  RefundedToOriginalPaymentMethod = "refunded_to_original_payment_method",
  ExchangeOrderCreated = "exchange_order_is_created",
  RefundedToStoreCredit = "refunded_to_store_credit",
}

/**
 * merchant列表
 */
export enum eventMerchantStatusType {
  ReturnRequestConfirmationMerchant = "return_request_confirmation_merchant",
  TrackingNumberAddedByCustomer = "tracking_number_added_by_customer",
}

export type variablesType = {
  key: string
  label: string
  value: string
  id: number
}

export type fixContentsType = {
  name: string
  text: string
}

export type positionItem = {
  position: number
  content: string
}

export type emailConfig = {
  type: string
  subject: string
  title: string
  body: positionItem[]
  button: positionItem[]
  style: {
    type: number // 1, 2
    logo: string
    logo_width: number
    text: string
    button_color: string
  }
  code: string
}

export enum moduleType {
  title,
  position1,
  position2,
  position3,
  position4,
  position5,
  position6,
  buttonName1,
  buttonName2,
  logo,
  storeName,
}
